var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('div',{staticClass:"text-h4 my-10 mb-12"},[_vm._v(" Den här sidan finns tyvärr inte. ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }